import { Component } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { TopMenuService } from "./shared/components/top-menu/top-menu.service";
import { AuthenticationService } from './core/services';
import { Renderer2, ElementRef, OnInit } from '@angular/core';
import { EventAggregator } from './core/event-aggregator/event.aggregator';
import { MessageSentEvent } from './core/event-aggregator/events/message.sent.event';
import { MessageSentEventPayload } from './core/event-aggregator/events/message.sent.event.payload';
import { HxEvent } from './core/event-aggregator/events/event';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalVariables } from './core/services/global.variables';
import { Boxes } from './shared/components/select-boxes/boxes';
import { environment } from '../environments/environment';
import { ApiService } from './core/services/api.service';
import * as _moment from 'moment'; const moment = _moment;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['../assets/stylesheets/core/reset.scss', '../assets/stylesheets/core/grid.scss'
        , '../assets/stylesheets/core/grid-base.scss', './app.component.scss',
        '../../node_modules/angular-notifier/styles/core.scss', '../../node_modules/angular-notifier/styles/themes/theme-material.scss',
        '../../node_modules/angular-notifier/styles/types/type-success.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

    box: ElementRef;
    boxes: Boxes;
    env: any;

    migrationDate: string;
    migrated = false;
    migratedAt: string;

    private static readonly URGENT_THRESHOLD_DAYS = 7;
    private static readonly GRACE_PERIOD_DAYS = 14;
    readonly newDashboardUrl = "https://oneview.hexoskin.com/";

    constructor(
        private authenticationService: AuthenticationService,
        private eventAggregator: EventAggregator,
        private globalVariables: GlobalVariables,
        private router: Router,
        private route: ActivatedRoute,
        private renderer: Renderer2, private el: ElementRef,
        private topMenuService: TopMenuService,
        private apiService: ApiService) {
    }


    childEventClicked(boxes: Boxes) {

        this.boxes = boxes;
    }

    ngOnInit() {

        this.env = environment;
        console.log(this.env);
        // A logout initiated from another dashboard (e.g. OneView) redirects
        // here with `logout=1` instead of going through this app's own
        // logout flow, so our locally-stored auth state is never cleared on
        // that path. Clear it here when we detect the flag.
        if (this.route.snapshot.queryParamMap.get('logout') === '1') {
            this.authenticationService.clearLocalStorage();
        }
        // set a user context for Sentry
        if (this.authenticationService.isLoggedIn()) {
            this.topMenuService.showNavBar(true);
            this.fetchMigrationStatus();
        } else {
            this.topMenuService.showNavBar(false);
            // todo login
        }
        this.renderer.addClass(this.el.nativeElement, 'partial-main');
        this.eventAggregator.getEvent(MessageSentEvent).subscribe(this.onMessageReceived);
    }

    private fetchMigrationStatus() {
        const currentUser = this.globalVariables.get('currentUser');
        const profileId = currentUser && currentUser.profile && currentUser.profile.id;
        if (!profileId) return;

        this.apiService.getFromUri('api/profile/' + profileId + '/').subscribe(
            (profile) => {
                this.migrationDate = profile && profile.migration_date;
                this.migrated = !!(profile && profile.migrated);
                this.migratedAt = profile && profile.migrated_at;
            },
            () => { /* keep banner hidden if profile fetch fails */ }
        );
    }

    get isUrgent(): boolean {
        if (!this.migrationDate) return false;
        const daysLeft = moment(this.migrationDate).startOf('day').diff(moment().startOf('day'), 'days');
        return daysLeft <= AppComponent.URGENT_THRESHOLD_DAYS;
    }

    get isInGracePeriod(): boolean {
        if (!this.migrated || !this.migratedAt) return false;
        return moment().isBefore(this.gracePeriodEnd);
    }

    get isLocked(): boolean {
        return this.migrated && !this.isInGracePeriod;
    }

    private get gracePeriodEnd(): _moment.Moment {
        return moment(this.migratedAt).add(AppComponent.GRACE_PERIOD_DAYS, 'days');
    }

    get migrationBannerText(): string {
        if (this.isInGracePeriod) {
            const formattedDate = this.gracePeriodEnd.format('MM/DD/YYYY');
            return `Your account has been migrated to the new platform at ${this.newDashboardUrl}. This dashboard is now read-only and will be disabled on ${formattedDate}.`;
        }

        if (!this.migrationDate) return null;

        const formattedDate = moment(this.migrationDate).format('MM/DD/YYYY');

        return this.isUrgent
            ? `This dashboard will be replaced by a new version very soon, on ${formattedDate}. Starting that date, you will need to use ${this.newDashboardUrl} to access your data — no action is required from you before then.`
            : `This dashboard will be replaced by a new version on ${formattedDate}. Starting that date, you will need to use ${this.newDashboardUrl} to access your data — no action is required from you before then.`;
    }

    private onMessageReceived = (payload: MessageSentEventPayload) => {

        const that = this;
        if (payload.object.msg === HxEvent.MAIN__FULL_SCREEN) {
            that.renderer.removeClass(this.el.nativeElement, 'partial-main');
            that.renderer.addClass(this.el.nativeElement, 'full-main');
        } else if (payload.object.msg === HxEvent.MAIN__PARTIAL_SCREEN) {
            that.renderer.removeClass(this.el.nativeElement, 'full-main');
            that.renderer.addClass(this.el.nativeElement, 'partial-main');
        /*} else if (payload.object.msg === HxEvent.ERROR) {
            this.displayError(payload.object.text);*/
        } else if (payload.object.msg === 401) {
            this.authenticationService.logout().subscribe(() => {
                this.router.navigate(['/']);
            });
        } else if (payload.object.msg === HxEvent.LOGOUT) {
            localStorage.clear(); // clear all data in localstorage
            window.location.href = environment.apiURL + '/api/connect/logout/'; // explicit logout from the serveur
        }
    }

    /*displayError(errors: Array<string>) {
        let text = "";

        for (let key in errors) {
            if (errors.hasOwnProperty(key)) {
                text += key + " : ";
                if (errors.hasOwnProperty(key)) {
                    for (let error of errors[key]) {
                        text += error;
                    }
                }
            }
        }
    }*/

}


